import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  Tooltip,
  Chip,
} from '@mui/material'
import { Delete as DeleteIcon } from '@mui/icons-material'

interface LogicGroupHeaderProps {
  operator: 'AND' | 'OR'
  onOperatorChange: (operator: 'AND' | 'OR') => void
  onDelete: () => void
  canDelete?: boolean
  /** Show "OR" chip to indicate groups are OR'd together */
  showOrIndicator?: boolean
}

export function LogicGroupHeader({
  operator,
  onOperatorChange,
  onDelete,
  canDelete = true,
  showOrIndicator = false,
}: LogicGroupHeaderProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {/* OR indicator between groups */}
      {showOrIndicator && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <Chip
            label="OR"
            size="small"
            sx={{
              bgcolor: 'warning.light',
              color: 'warning.contrastText',
              fontWeight: 'bold',
              fontSize: '0.75rem',
            }}
          />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Logic Group
          </Typography>
          <ToggleButtonGroup
            value={operator}
            exclusive
            onChange={(_, newOperator) => {
              if (newOperator) {
                onOperatorChange(newOperator)
              }
            }}
            size="small"
          >
            <ToggleButton value="AND" sx={{ px: 2 }}>
              <Tooltip title="All criteria in this group must be met">
                <span>AND</span>
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="OR" sx={{ px: 2 }}>
              <Tooltip title="Any criteria in this group can be met">
                <span>OR</span>
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {canDelete && (
          <Tooltip title="Delete group and all criteria in it">
            <IconButton size="small" onClick={onDelete} color="error">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}
